import { render, staticRenderFns } from "./DigitalFlipper.vue?vue&type=template&id=21cbd4ee&scoped=true"
import script from "./DigitalFlipper.vue?vue&type=script&lang=js"
export * from "./DigitalFlipper.vue?vue&type=script&lang=js"
import style0 from "./DigitalFlipper.vue?vue&type=style&index=0&id=21cbd4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbd4ee",
  null
  
)

export default component.exports